/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import TextField from "@mui/material/TextField";

const Input = (props) => {
  const sanitizeValue = (e, change) => {
    const sanitizedValue = e.target.value.replace(
      /[^\x09\x0A\x0D\x20-\x7E]/g,
      "",
    );
    e.target.value = sanitizedValue;
    return change(e);
  };
  return props.type ? (
    props.type === "file" ||
    (props.inputProps && props.inputProps.type === "file") ? (
      <TextField
        name={props.name}
        value={props.value}
        id={props.id}
        // onChange={(e) => props.type === 'text' ? sanitizeValue(e, props.onChange) : props.onChange}
        // onChange={(props.type === 'text' || (props.inputProps && props.inputProps.multiline || props.multiline)) ? (e) => sanitizeValue(e, props.onChange) : props.onChange}
        onChange={props.onChange}
        onClick={props.onClick}
        label={props.placeholder}
        className={
          props.className + (props.multiline ? " multiline-input-field" : "")
        }
        min={props.min}
        type={props.type}
        variant={props.variant ? props.variant : "outlined"}
        size={props.size ? props.size : "small"}
        disabled={props.disabled}
        onKeyDown={props.onKeyDown}
        onBlur={props.onBlur}
        style={props.style}
        step={props.step}
        autoComplete={props.autoComplete ? props.autoComplete : "off"}
        InputProps={props.InputProps}
        inputProps={
          props.multiline || (props.inputProps && props.inputProps.multiline)
            ? props.inputProps
            : { ...props.inputProps, maxLength: 60 }
        }
        multiline={props.multiline}
        {...props.inputProps}
        error={props.error}
        helperText={props.helperText}
      />
    ) : (
      <TextField
        name={props.name}
        value={props.value}
        id={props.id}
        // onChange={(e) => props.type === 'text' ? sanitizeValue(e, props.onChange) : props.onChange}
        onChange={
          props.type === "text" ||
          (props.inputProps && props.inputProps.multiline) ||
          props.multiline
            ? (e) => sanitizeValue(e, props.onChange)
            : props.onChange
        }
        // onChange={props.onChange}
        onClick={props.onClick}
        label={props.placeholder}
        className={
          props.className +
          (props.multiline
            ? " multiline-input-field"
            : " input-placeholder-wrapper")
        }
        min={props.min}
        type={props.type}
        variant={props.variant ? props.variant : "outlined"}
        size={props.size ? props.size : "small"}
        disabled={props.disabled}
        onKeyDown={props.onKeyDown}
        onBlur={props.onBlur}
        style={props.style}
        step={props.step}
        autoComplete={props.autoComplete ? props.autoComplete : "off"}
        InputProps={props.InputProps}
        InputLabelProps={props.InputLabelProps}
        inputProps={
          props.multiline || (props.inputProps && props.inputProps.multiline)
            ? props.inputProps
            : { ...props.inputProps, maxLength: 60 }
        }
        multiline={props.multiline}
        {...props.inputProps}
        error={props.error}
        helperText={props.helperText}
      />
    )
  ) : (
    <TextField
      name={props.name}
      value={props.value}
      id={props.id}
      // onChange={(e) => props.type === 'text' ? sanitizeValue(e, props.onChange) : props.onChange}
      onChange={(e) => sanitizeValue(e, props.onChange)}
      // onChange={props.onChange}
      onClick={props.onClick}
      label={props.placeholder}
      className={
        props.className +
        (props.multiline
          ? " multiline-input-field"
          : " input-placeholder-wrapper")
      }
      min={props.min}
      type={props.type}
      variant={props.variant ? props.variant : "outlined"}
      size={props.size ? props.size : "small"}
      disabled={props.disabled}
      onKeyDown={props.onKeyDown}
      onBlur={props.onBlur}
      style={props.style}
      step={props.step}
      autoComplete={props.autoComplete ? props.autoComplete : "off"}
      InputProps={props.InputProps}
      inputProps={
        props.multiline || (props.inputProps && props.inputProps.multiline)
          ? props.inputProps
          : { ...props.inputProps, maxLength: 60 }
      }
      multiline={props.multiline}
      {...props.inputProps}
      error={props.error}
      helperText={props.helperText}
    />
  );
};

export default Input;
